const pages2 = {
  resources: {
    eyebrow: "Knowledge",
    title: "GPU Knowledge Center",
    lead: "Acts, rules, official updates, circulars, SOPs and training material — organised for licensed traders.",
    categories: [
      { key: "dca", title: "Drugs & Cosmetics Act", body: "Primary statute governing manufacture, sale and distribution of drugs in India." },
      { key: "rules", title: "Drug Rules", body: "Rules, schedules and forms applicable to wholesale and distribution licences." },
      { key: "fdca", title: "FDCA Gujarat Updates", body: "State-level notices and communications relevant to Gujarat trade." },
      { key: "cdsco", title: "CDSCO Updates", body: "Central regulatory alerts, drug alerts and public notices." },
      { key: "notifications", title: "Government Notifications", body: "Gazette notifications and departmental orders." },
      { key: "circulars", title: "GPU Circulars", body: "Official circulars issued by the GPU secretariat." },
      { key: "guides", title: "Compliance Guides", body: "Practical guidance on records, storage and documentation." },
      { key: "sops", title: "Safe Purchase SOPs", body: "Standard operating procedures for supplier due diligence." },
      { key: "training", title: "Training Material", body: "Workshop decks, checklists and awareness material." },
      { key: "faqs", title: "FAQs", body: "Frequently asked questions on membership, vendors and verification." },
    ],
    note: "Documents are published by the GPU secretariat. Restricted material requires Member login in the GPU application.",
  },

  downloads: {
    eyebrow: "Resources",
    title: "Download Center",
    lead: "Public documents are available to everyone. Restricted documents require authenticated Member access.",
    publicItems: [
      { title: "GPU Brochure", body: "Overview of the organisation, objectives and structure." },
      { title: "Membership Guide", body: "Eligibility, documents and the ten-stage member journey." },
      { title: "Vendor Guide", body: "Categories, credentials and the vendor verification journey." },
      { title: "GPU Code of Ethics", body: "The eleven ethical trade commitments." },
      { title: "Safe Trade Awareness Guide", body: "Practical supplier due-diligence discipline." },
    ],
    restrictedItems: [
      "Membership Agreement (full text)",
      "Vendor Agreement (full text)",
      "Legal Support Request Formats",
      "District Committee Minutes",
      "Member-only Compliance Templates",
    ],
    note: "Files are uploaded by the GPU secretariat. Download links appear here once documents are officially published.",
  },

  faq: {
    eyebrow: "Help",
    title: "Frequently Asked Questions",
    lead: "Clear, responsible answers about membership, vendors and the limits of GPU verification.",
    groups: [
      {
        title: "Membership",
        items: [
          { q: "Who can become a GPU Member?", a: "Eligible Gujarat pharmaceutical traders meeting GPU requirements, including valid GST registration, an applicable drug licence and business KYC." },
          { q: "Can an out-of-Gujarat business become a Member?", a: "Not under the current Member policy. Such a business may register as a Vendor if it is otherwise eligible." },
          { q: "What documents are required?", a: "GST registration, the applicable Drug Licence and business KYC documents of the entity and its authorized representative." },
          { q: "Where do I complete registration?", a: "Registration is completed inside the official GPU mobile application and member portal. This website only links to it." },
        ],
      },
      {
        title: "Vendor",
        items: [
          { q: "Can a Maharashtra, Rajasthan or Delhi Vendor register?", a: "Yes, subject to GPU policy and successful verification. Vendors may be based in Gujarat or in other Indian states." },
          { q: "Does vendor registration guarantee sales?", a: "No. Vendor registration provides visibility and a structured compliance identity. It does not guarantee orders, sales or commercial performance." },
          { q: "Does vendor status reduce a supplier's own responsibility?", a: "No. Vendor registration does not relieve any supplier from its statutory, contractual or product-quality responsibilities." },
        ],
      },
      {
        title: "Verification",
        items: [
          { q: "Does GPU Verified Vendor mean every medicine is genuine?", a: "No. GPU verification relates to reviewed business credentials and compliance status. It is not a guarantee regarding the authenticity or quality of every medicine or batch supplied." },
          { q: "Is GPU verification a Government certification?", a: "No. GPU is an independent trade body. GPU verification is carried out under GPU's own policy and is not a Government certification, licence or approval." },
          { q: "Does GPU provide legal immunity?", a: "No. GPU provides structured support, guidance and access to professional assistance. It does not and cannot provide immunity from law." },
          { q: "Can GPU stop Drug Department action?", a: "No. GPU does not obstruct lawful inspection, investigation or regulatory action. GPU helps eligible Members maintain proper documentation and respond responsibly." },
        ],
      },
    ],
  },

  districts: {
    eyebrow: "Network",
    title: "District Chapters",
    lead: "GPU is organised district by district. Committee details, member counts, meetings and local announcements for each district are published by the GPU secretariat.",
    list: [
      "Ahmedabad", "Amreli", "Anand", "Aravalli", "Banaskantha", "Bharuch", "Bhavnagar", "Botad",
      "Chhota Udepur", "Dahod", "Dang", "Devbhoomi Dwarka", "Gandhinagar", "Gir Somnath", "Jamnagar",
      "Junagadh", "Kheda", "Kutch", "Mahisagar", "Mehsana", "Morbi", "Narmada", "Navsari",
      "Panchmahal", "Patan", "Porbandar", "Rajkot", "Sabarkantha", "Surat", "Surendranagar",
      "Tapi", "Vadodara", "Valsad",
    ],
    fields: ["District Committee", "Member Count", "District Contact", "Local Meetings", "Local Announcements"],
  },

  committees: {
    eyebrow: "Governance",
    title: "GPU Leadership & Committees",
    lead: "Committee composition is published only after formal approval by the GPU secretariat. No names or photographs are displayed until officially provided.",
    groups: [
      { key: "state", title: "State Leadership", body: "Office bearers responsible for state-level direction and representation." },
      { key: "executive", title: "Executive Committee", body: "Operational governance, policy execution and district coordination." },
      { key: "legal", title: "Legal & Regulatory Committee", body: "Legal support framework, notices, regulatory interpretation and liaison." },
      { key: "compliance", title: "Compliance Committee", body: "Verification policy, due-diligence standards and audits." },
      { key: "membership", title: "Membership Committee", body: "Eligibility review, maker-checker verification and grievance handling." },
      { key: "media", title: "Media & Communication Committee", body: "Official statements, press relations and responsible communication." },
      { key: "district", title: "District Chapters", body: "District-level committees across Gujarat." },
    ],
  },

  news: {
    eyebrow: "Newsroom",
    title: "News & Updates",
    lead: "Official communications, regulatory updates, events and statements from Gujarat Pharma Union.",
    filters: ["All", "GPU News", "Regulatory Updates", "Events", "Training", "Official Statements", "Media"],
    empty: "No posts have been published yet. Official GPU communications will appear here.",
  },

  events: {
    eyebrow: "Calendar",
    title: "Events & Meetings",
    lead: "Upcoming meetings, seminars, training programmes, the Annual General Meeting and district gatherings.",
    types: ["Upcoming Meetings", "Seminars", "Training", "AGM", "District Meetings"],
    empty: "No events are currently scheduled. Announcements will be published here.",
  },

  media: {
    eyebrow: "Press",
    title: "Media & Official Communications",
    lead: "Only Admin-approved statements are published on this page. Please do not attribute any position to GPU that does not appear here.",
    sections: ["Official Press Releases", "GPU Statements", "Media Coverage", "Spokesperson Contact"],
    note: "Media queries should be sent through the Contact page under the 'Media' category. A designated spokesperson responds to accredited media.",
  },

  verify: {
    eyebrow: "Public tool",
    title: "Verify GPU ID",
    lead: "Enter a GPU Member Code or GPU Vendor Code to view publicly available status information.",
    placeholder: "GPU-M-000125",
    button: "Verify",
    fields: { firm: "Firm", district: "District", status: "Status", validity: "Validity", type: "Type", code: "Code" },
    notFound: "No public record was found for this code. Please re-check the code with your counterparty.",
    note: "Only limited public information is displayed. KYC documents, licence images and private records are never shown here.",
    disclaimer: "A verified status confirms the completion of GPU's credential review under GPU policy. It is not a Government certification and is not a guarantee regarding any specific product or batch.",
  },

  contact: {
    eyebrow: "Contact",
    title: "Contact Gujarat Pharma Union",
    lead: "For membership, vendor, compliance, media, institutional or general enquiries.",
    form: {
      name: "Full Name",
      email: "Email Address",
      phone: "Phone",
      organisation: "Firm / Organisation",
      district: "District",
      category: "Enquiry Category",
      message: "Message",
      submit: "Send Enquiry",
      sending: "Sending…",
      success: "Your enquiry has been received. The GPU secretariat will respond shortly.",
      error: "We could not send your enquiry. Please check the details and try again.",
      categories: [
        { value: "membership", label: "Membership" },
        { value: "vendor", label: "Vendor" },
        { value: "compliance", label: "Compliance" },
        { value: "media", label: "Media" },
        { value: "government", label: "Government / Institution" },
        { value: "general", label: "General" },
      ],
    },
    labels: {
      registeredOffice: "Registered Office",
      supportOffice: "Support Office",
      phone: "Phone",
      email: "Email",
      whatsapp: "WhatsApp",
      hours: "Office Hours",
    },
    legalNote:
      "Please do not submit case-specific legal or investigation details through this public form. Members must log in to the GPU application to raise a confidential support request.",
  },

  privacy: {
    eyebrow: "Legal",
    title: "Privacy Policy",
    lead: "How Gujarat Pharma Union collects, uses, stores and protects information.",
    review: true,
    sections: [
      { heading: "Data We Collect", body: ["Identification and contact details of the firm and its authorized representative, enquiry details submitted through this website, and technical information such as browser type and pages visited."] },
      { heading: "Purpose of Processing", body: ["To respond to enquiries, evaluate membership and vendor eligibility, maintain verification records, issue circulars and communications, and meet legal or regulatory obligations."] },
      { heading: "KYC Information", body: ["KYC information is collected only inside the authenticated GPU application, not through this public website. It is used solely for eligibility verification and recordkeeping."] },
      { heading: "Documents", body: ["Uploaded documents such as GST certificates and drug licences are stored with restricted access and used only for verification and audit purposes."] },
      { heading: "Verification", body: ["Verification outcomes, dates and status are recorded. Limited status information may be shown through the public Verify GPU ID tool."] },
      { heading: "Cookies", body: ["Strictly necessary cookies are used for site functionality. Analytics or preference cookies, where used, are subject to your consent."] },
      { heading: "Communications", body: ["Circulars, regulatory updates and organisational notices may be sent to members and registered contacts."] },
      { heading: "Service Providers", body: ["Processing may involve hosting, communication and verification service providers bound by confidentiality obligations."] },
      { heading: "Security", body: ["Access controls, encryption in transit, restricted document storage and audit logging are applied."] },
      { heading: "Retention", body: ["Information is retained for the period required for verification, contractual, statutory and audit purposes."] },
      { heading: "Your Rights", body: ["You may request access to, correction of, or deletion of your information, subject to legal and regulatory retention requirements."] },
      { heading: "Contact", body: ["Privacy queries may be raised through the Contact page under the 'General' category."] },
    ],
  },

  terms: {
    eyebrow: "Legal",
    title: "Terms of Use",
    lead: "The terms on which this website may be accessed and used.",
    review: true,
    sections: [
      { heading: "Informational Purpose", body: ["This website provides general information about Gujarat Pharma Union. Content may be updated without notice and does not constitute professional advice."] },
      { heading: "No Legal Immunity", body: ["Nothing on this website creates, implies or provides immunity from any law, inspection, investigation or regulatory action."] },
      { heading: "No Product Guarantee", body: ["GPU does not guarantee the authenticity, quality, efficacy or safety of any medicine, batch or consignment supplied by any Member or Vendor."] },
      { heading: "No Government Affiliation", body: ["GPU is an independent trade body. No Government affiliation, approval or certification is claimed unless officially established and expressly stated."] },
      { heading: "User Information Responsibility", body: ["You are responsible for the accuracy, completeness and lawfulness of information you submit."] },
      { heading: "Intellectual Property", body: ["The GPU name, logo, content and design are protected. Reproduction without written permission is prohibited."] },
      { heading: "Acceptable Use", body: ["No scraping, automated abuse, spamming, impersonation, unlawful use or attempt to compromise site security is permitted."] },
      { heading: "Limitation of Liability", body: ["To the extent permitted by law, GPU shall not be liable for indirect, incidental or consequential loss arising from use of this website."] },
      { heading: "Applicable Law", body: ["These terms are governed by the laws of India, with jurisdiction in Gujarat."] },
    ],
  },

  disclaimer: {
    eyebrow: "Legal",
    title: "Disclaimer",
    lead: "Please read these disclaimers carefully before relying on any information on this website.",
    review: true,
    sections: [
      { heading: "GPU Verification Disclaimer", body: ["GPU verification concerns business credentials reviewed under GPU policy. It reflects declared and reviewed documentation as on the stated verification date and nothing more."] },
      { heading: "Product Disclaimer", body: ["GPU does not guarantee the authenticity or quality of every product supplied by any Member or Vendor. Each party remains fully responsible for its own statutory and product-quality obligations."] },
      { heading: "Legal Disclaimer", body: ["Website content is general information and does not substitute case-specific legal advice. Members should obtain independent professional advice for their own matters."] },
      { heading: "Government Disclaimer", body: ["GPU is an independent trade body unless otherwise explicitly stated. GPU does not represent, and must not be presented as representing, any Government department or regulatory authority."] },
    ],
  },
};

export default pages2;
